export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-disabled-1200-d8e94cd4f03b87067d4f3044a94ebb66.webp";